import React, { useState } from 'react';
import styled from 'styled-components';
import ScreenFooter from '../layout/ScreenFooter';
import SNS from './SNS';
import MainMenu from './MainMenu';
import Notice from './Notice';
import Stamp from './Stamp';
import Wallet from './Wallet';
import Gps from './Gps';

const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

const Bridge: React.FC = () => {
  const [active, setActive] = useState('');
  return (
    <Wrapper>
      {active === '' && <MainMenu setActive={setActive} />}
      {active === 'stamp' && <Stamp type="parents" />}
      {active === 'wallet' && <Wallet />}
      {active === 'notice' && <Notice type="notice" screenType="parents" />}
      {active === 'homework' && <Notice type="homework" screenType="parents" />}
      {active === 'sns' && <SNS type="parents" />}
      {active === 'gps' && <Gps />}
      {active !== '' && <ScreenFooter setActive={setActive} active={active} type="parents" />}
    </Wrapper>
  );
};

export default Bridge;
